/*
 * Turns the product row of the "Image, text, products" section into a slider
 * below the breakpoint and destroys it above, so the desktop grid is untouched.
 * Swiper itself is loaded globally by layout/theme.liquid.
 */
(function () {
	const BREAKPOINT = 990;
	const SELECTOR = ".image-with-text-products__list--slider";
	const instances = new WeakMap();

	function isMobile() {
		return window.matchMedia("(max-width: " + (BREAKPOINT - 1) + "px)").matches;
	}

	function sync() {
		if (typeof Swiper === "undefined") return;
		document.querySelectorAll(SELECTOR).forEach(function (slider) {
			const instance = instances.get(slider);
			if (isMobile()) {
				if (instance) return;
				instances.set(
					slider,
					new Swiper(slider, {
						slidesPerView: 1,
						spaceBetween: 16,
						keyboard: true,
						watchOverflow: true,
						navigation: {
							nextEl: slider.querySelector(".swiper-button-next"),
							prevEl: slider.querySelector(".swiper-button-prev"),
						},
					})
				);
			} else if (instance) {
				instance.destroy(true, true);
				instances.delete(slider);
			}
		});
	}

	let resizeTimer;
	window.addEventListener("resize", function () {
		clearTimeout(resizeTimer);
		resizeTimer = setTimeout(sync, 150);
	});
	document.addEventListener("shopify:section:load", sync);

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", sync);
	} else {
		sync();
	}
})();
